import {normalizeTagName} from '../utils';

export default [
	// tag name
	({searchTerm, selectedTag}) =>
		searchTerm || !selectedTag
			? false // no predicate
			: ({tag_names: tags = ''}) =>
					tags.split(',').map(normalizeTagName).indexOf(selectedTag) >
					-1,

	// time
	({searchTerm, startTimestamp: filterStart, endTimestamp: filterEnd}) => {
		// search active or no filter
		if (searchTerm || (!filterStart && !filterEnd)) {
			return false; // no predicate
		}

		return ({timestamp_from: eventStart, timestamp_to: eventEnd}) => {
			// open start
			if (!filterStart) {
				return !eventStart || eventStart < filterEnd;
			}

			// open end
			if (!filterEnd) {
				return !eventEnd || eventEnd >= filterStart;
			}

			return (
				(eventEnd > filterStart && eventEnd <= filterEnd) || // event ends inside range
				(eventStart < filterEnd && eventStart >= filterStart) || // event starts inside range
				(eventStart <= filterStart &&
					(!eventEnd || eventEnd >= filterEnd)) // event contains range
			);
		};
	},

	// text search
	({searchTerm}) => {
		if (!searchTerm) {
			return false; // no predicate
		}

		const needle = searchTerm.trim().toLowerCase();
		return ({search}) =>
			search && search.toLowerCase().indexOf(needle) > -1;
	},
];
